import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";
import RouteService, { RouteType } from "@/src/application/services/route-service";
import { useInject } from "@/src/presentation/hooks/useInject";

export const Route = createFileRoute("/_public")({
  component: PublicLayout,
});

function PublicLayout() {
  const routeService = useInject<RouteService>(RouteService);

  useEffect(() => {
    routeService.setRouteType(RouteType.PUBLIC);
  }, [routeService]);

  return <Outlet />;
}
